{
  "display_name": "Andre",
  "donations_count": 14,
  "donations_total_dollars": "$8,420",
  "household_name": "Andre's household",
  "pdf_url": "https://dev.hearthfire.ai/api/annual-review/2025.pdf",
  "site_domain": "dev.hearthfire.ai",
  "tax_year": "2025"
}
